/**
 * Created by Digital Awesome
 * https://digitalaweso.me
 * User: Oren Reuveni
 * Date: 15/07/2017
 * Time: 6:27
 */


//Import plugins
import 'script-loader!../node_modules/jquery/dist/jquery'
import 'script-loader!../node_modules/tether/dist/js/tether'
import 'script-loader!../node_modules/bootstrap/dist/js/bootstrap'
import 'script-loader!../node_modules/isotope-layout/dist/isotope.pkgd'
import 'script-loader!../node_modules/imagesloaded/imagesloaded'
import 'script-loader!../node_modules/slick-carousel/slick/slick'



//Import scripts
import './script'


//Import styles
import '../styles/main.scss'


// WEBPACK FOOTER //
// ./js/index.js